import { render, staticRenderFns } from "./workImportTemplate.vue?vue&type=template&id=5afdf28d&scoped=true&"
import script from "./workImportTemplate.vue?vue&type=script&lang=js&"
export * from "./workImportTemplate.vue?vue&type=script&lang=js&"
import style0 from "./workImportTemplate.vue?vue&type=style&index=0&id=5afdf28d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afdf28d",
  null
  
)

export default component.exports